import { GlobalResponseObject } from "../../global-response-object";
import { DateDetail } from "./date-detail";


export class DateDetailsResponse extends GlobalResponseObject{
data?:DateDetail;
constructor(status: boolean, intlCode: number, internalMessage: string, data?:DateDetail){
    super(status,intlCode,internalMessage)
    this.data = data;
} 
}